import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './assets/i18n/locales/en/translation.json';
import translationFR from './assets/i18n/locales/fr/translation.json';

const languages = ['en', 'fr'];
const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
};

let initialLanguage = localStorage.getItem('language');
const checkLanguage = languages.includes(initialLanguage);
if (!checkLanguage) {
  initialLanguage = 'en';
  localStorage.setItem('language', 'en');
}

i18n.use(initReactI18next).init({
  fallbackLng: initialLanguage || 'en',
  resources,
  supportedLngs: languages,
  debug: false,
  interpolation: { escapeValue: false },
});

export const syncLanguageWithBackend = (backendLanguage) => {
  if (backendLanguage && languages.includes(backendLanguage)) {
    const currentLanguage = i18n.language;
    if (currentLanguage !== backendLanguage) {
      i18n.changeLanguage(backendLanguage);
      localStorage.setItem('language', backendLanguage);
    }
  }
};

export default i18n;
